// extracted by mini-css-extract-plugin
export default {"border-styling":"styles_border-styling__9nHCS"};